@if (data) {
    <div class="import-status-tooltip">
        <div class="tooltip-header">
            <h3>{{ 'exports.imports-monitoring.statusBar.header' | translate }}</h3>
            <div class="summary-stats">
                <span class="stat total">{{ data.numberOfTotalItems }} {{ 'exports.imports-monitoring.statusBar.total' | translate }}</span>
                <span class="stat success">{{ data.numberOfSuccessfulItems }} ✓</span>
                @if (data.numberOfPartialSuccessfulItems > 0) {
                    <span class="stat partial">{{ data.numberOfPartialSuccessfulItems }} ⚠</span>
                }
                @if (data.numberOfFailedItems > 0) {
                    <span class="stat error">{{ data.numberOfFailedItems }} ✗</span>
                }
            </div>
        </div>
        <div class="status-breakdown">
            @if (data.numberOfSuccessfulItems > 0) {
                <div class="breakdown-item success">
                    <div class="breakdown-label">
                        <i class="fas fa-check-circle"></i>
                        <span>{{ 'exports.imports-monitoring.statusBar.successful' | translate }}</span>
                    </div>
                    <div class="breakdown-value">
                        <span class="count">{{ data.numberOfSuccessfulItems }}</span>
                        <span class="percentage">({{ data.adjustedSuccessPercentage }}%)</span>
                    </div>
                </div>
            }

            @if (data.numberOfPartialSuccessfulItems > 0) {
                <div class="breakdown-item partial">
                    <div class="breakdown-label">
                        <i class="fas fa-exclamation-triangle"></i>
                        <span>{{ 'exports.imports-monitoring.statusBar.partialSuccess' | translate }}</span>
                    </div>
                    <div class="breakdown-value">
                        <span class="count">{{ data.numberOfPartialSuccessfulItems }}</span>
                        <span class="percentage">({{ data.adjustedPartialSuccessPercentage }}%)</span>
                    </div>
                </div>
            }

            @if (data.numberOfFailedItems > 0) {
                <div class="breakdown-item error">
                    <div class="breakdown-label">
                        <i class="fas fa-times-circle"></i>
                        <span>{{ 'exports.imports-monitoring.statusBar.failed' | translate }}</span>
                    </div>
                    <div class="breakdown-value">
                        <span class="count">{{ data.numberOfFailedItems }}</span>
                        <span class="percentage">({{ data.adjustedFailurePercentage }}%)</span>
                    </div>
                </div>
            }
        </div>
    </div>
}
